import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) { toast.success("Welcome to GlowCart"); nav("/"); }
    else setError(res.error);
  };

  return (
    <div data-testid="register-page" className="pt-32 pb-24 max-w-md mx-auto px-4">
      <h1 className="font-display font-black text-4xl tracking-tighter mb-2">Join the glow</h1>
      <p className="text-zinc-400 text-sm mb-8">Create an account to buy, sell, and shine.</p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Name</label>
          <input data-testid="register-name-input" required value={name} onChange={(e) => setName(e.target.value)} className="input-dark mt-2" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Email</label>
          <input data-testid="register-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark mt-2" />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest text-zinc-500">Password</label>
          <input data-testid="register-password-input" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark mt-2" />
        </div>
        {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="register-submit-btn" disabled={loading} className="btn-primary w-full">{loading ? "Creating…" : "Create account"}</button>
      </form>
      <p className="text-sm text-zinc-500 mt-6">Already a member? <Link to="/login" className="text-[#05D9E8] hover:underline" data-testid="goto-login">Sign in</Link></p>
    </div>
  );
}
